import { PEOPLE, SECTION_IDS } from "./content";

export const People = () => (
  <section
    id={SECTION_IDS.about}
    className="relative overflow-hidden bg-ink-3 px-[clamp(16px,4vw,64px)] py-[clamp(110px,15vw,230px)]"
  >
    <div
      className="absolute inset-0 opacity-35"
      style={{
        backgroundImage:
          "repeating-radial-gradient(circle at 22% 42%, transparent 0 38px, rgba(127,232,180,.07) 38px 39px)",
      }}
    />

    <div className="dc-shell relative z-2">
      <div className="my-[clamp(24px,4vw,56px)] mb-[clamp(40px,5vw,72px)] flex flex-wrap items-center justify-center gap-[clamp(16px,3vw,44px)] text-center">
        <span className="text-[clamp(30px,5vw,78px)] font-bold tracking-[-.04em] text-mint">
          SCIENCE
        </span>
        <span className="inline-flex items-center gap-3">
          <span className="block h-px w-[clamp(30px,6vw,110px)] bg-[linear-gradient(90deg,rgba(127,232,180,.2),#7FE8B4)]" />
          <span className="relative block h-3 w-3 rounded-full bg-mint [animation:dc-pulse-dot_3s_ease-in-out_infinite]" />
          <span className="block h-px w-[clamp(30px,6vw,110px)] bg-[linear-gradient(90deg,#7FE8B4,rgba(127,232,180,.2))]" />
        </span>
        <span className="text-[clamp(30px,5vw,78px)] font-bold tracking-[-.04em] text-paper">
          ENGINEERING
        </span>
      </div>

      <p className="mx-auto mt-0 mb-[clamp(56px,7vw,96px)] max-w-[66ch] text-center text-[clamp(16px,1.4vw,20px)] leading-[1.75] text-mist-2">
        Haizea grew from two decades of environmental research and
        continental-scale monitoring at the Australian National University. The
        people who understand how landscapes behave work beside the people who
        know how to interrogate enormous amounts of data.
      </p>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,330px),1fr))] gap-[clamp(24px,3vw,56px)]">
        {PEOPLE.map((person) => (
          <div
            key={person.name}
            className="grid grid-cols-[120px_minmax(0,1fr)] gap-[26px] border-t border-white/[.16] pt-[26px]"
          >
            {/* Monogram placeholder — swap for a portrait once headshots are
                supplied; the design handoff flagged them as still required. */}
            <div
              aria-hidden="true"
              className="flex aspect-square items-center justify-center border border-white/[.08] bg-[linear-gradient(160deg,rgba(127,232,180,.14),rgba(53,195,224,.05))] text-[clamp(26px,2.4vw,34px)] font-semibold tracking-[-.02em] text-mint/80"
            >
              {person.initials}
            </div>
            <div>
              <h3 className="mt-0 mb-2 text-[clamp(19px,1.7vw,24px)] font-semibold tracking-[-.02em]">
                {person.name}
              </h3>
              <div className="dc-mono mb-4 text-[12px] uppercase tracking-[.14em] text-mint">
                {person.role}
              </div>
              <p className="m-0 text-[15px] leading-[1.75] text-mist-3">
                {person.bio}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
